export default __webpack_public_path__ + "static/media/ct213-5.6d823767.png";